<p-tabView [activeIndex]="tab" (activeIndexChange)="navigate($event)">
  <p-tabPanel header="Solicitações de reenvio">
    <ng-template pTemplate="content">
      <app-table
        [cols]="cols"
        [service]="shippingOrderService"
        [findPage]="findPage"
        [sortOrder]="1"
        [addButton]="false"
        dataKey="shippingOrderIdResend"
        expandField="items"
        [expansionCols]="productCols"
        (rowExpand)="findItems($event.$event, $event.service)"
        modelName="solicitações"
        [dropdownFilters]="dropdownFilters"
        [expandPaginator]="false"
        [rowBackground]="status() === 0 ? productBackground : undefined"
        [changeColumns]="true"
        [extraButton]="true"
        (extraButtonClick)="recalculateStocks()"
        extraLabel="Atualizar estoques"
        extraButtonTooltip="Verifica o estoque de pedidos AG. ESTOQUE"
        extraButtonTooltipPosition="bottom"
        selectionActionLabel="Revisar pedidos"
        selectionActionIcon="pi pi-file-check"
        selectionActionTooltip="Revisa os pedidos selecionados"
        selectionActionClass="p-button-highlight"
        (emitSelection)="validateResendOrders($event)"
        [rowSelectable]="rowSelectable"
        [hasChildren]="hasChildren"
        [multiSelectFilter]="true"
      />
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Solicitações de reenvio da loja">
    <ng-template pTemplate="content">
      <app-table
        [cols]="shopCols"
        [service]="shippingOrderService"
        pageFunctionName="findShopResendRequests"
        [sortOrder]="1"
        [addButton]="false"
        modelName="solicitações"
        [dropdownFilters]="dropdownFilters"
        [changeColumns]="true"
        [multiSelectFilter]="true"
      />
    </ng-template>
  </p-tabPanel>
</p-tabView>
<p-toast />
<p-dialog
  [(visible)]="showModal"
  *ngIf="selectionList?.length > 0"
  header="Revisão de pedidos"
  [style]="{ width: '90vw' }"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
>
  <div>
    <app-table
      [addButton]="false"
      [cols]="colsReview"
      [elements]="selectionList"
      [sortOrder]="1"
      modelName="Pedidos de reenvio"
      tableTitle="Pedidos para revisão"
      [exportExcel]="false"
      [exportPdf]="false"
      [lazy]="false"
    />
    <div *ngIf="requiresDuplicityConfirmation" class="duplicate-warning">
      <p *ngIf="hasTSimplesOrigin" class="duplicate-warning__title">
        <i class="pi pi-exclamation-triangle"></i>
        Atenção: a seleção contém reenvio(s) de origem <strong>TSimples</strong>
        (canal automático de falha de entrega). Reenvios dessa origem exigem
        confirmação consciente de duplicidade para serem aprovados.
      </p>
      <p *ngIf="hasDuplicates" class="duplicate-warning__title">
        <i class="pi pi-exclamation-triangle"></i>
        Atenção: esta(s) edição(ões) já possui(em)
        {{ duplicateResends.length }} outro(s) reenvio(s) não cancelado(s).
        Confirme conscientemente antes de aprovar.
      </p>
      <app-table
        *ngIf="hasDuplicates"
        [addButton]="false"
        [cols]="duplicateCols"
        [elements]="duplicateResends"
        [sortOrder]="1"
        modelName="reenvios da edição"
        tableTitle="Reenvios já existentes nesta(s) edição(ões)"
        [exportExcel]="false"
        [exportPdf]="false"
        [lazy]="false"
      />
      <div class="duplicate-warning__confirm">
        <p-checkbox
          [formControl]="confirmDuplicatesControl"
          [binary]="true"
          inputId="confirmDuplicates"
        />
        <label for="confirmDuplicates">
          Confirmo a duplicidade e desejo aprovar este(s) reenvio(s) mesmo assim.
        </label>
      </div>
    </div>
    <div class="modal-buttons">
      <p-button
        label="Aprovar"
        icon="pi pi-check"
        (onClick)="approveResendOrders()"
        [disabled]="requiresDuplicityConfirmation && !confirmDuplicatesControl.value"
        styleClass="p-button-success"
      />
      <p-button
        label="Rejeitar"
        icon="pi pi-times"
        (onClick)="rejectResendOrders()"
        styleClass="p-button-danger"
      />
    </div>
  </div>
</p-dialog>
